import axios from 'axios';
import { dateFormatHadith } from '../ConstantFunctions';
import { toast } from 'react-toastify';

export const HADITH_OF_THE_DAY_LOADER = 'HADITH_OF_THE_DAY_LOADER';
export const hadithOfTheDayLoader = payload => ({
  type: 'HADITH_OF_THE_DAY_LOADER',
  payload: payload,
});

export const hadithOfTheDayAction = (today, month, year) => {
  return async dispatch => {
    dispatch(hadithOfTheDayLoader(true));
    // setDeleteLoader(true)

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/hadithget?${today ? `today=${dateFormatHadith(today)}` : ''}${
        month && year ? `month=${month}&year=${year}` : ''
      }`,
      headers: {},
    };

    axios(config)
      .then(response => {
        if (today) {
          dispatch(hadithOfTheDayData(response.data.datas.todaydata));
        } else {
          dispatch(hadithOfTheMonthData(response.data.datas.getdate));
        }

        dispatch(hadithOfTheDayLoader(false));
      })
      .catch(error => {
        // setDeleteLoader(false)
        dispatch(hadithOfTheDayLoader(false));
      });
  };
};

export const HADITH_OF_THE_DAY_DATA = 'HADITH_OF_THE_DAY_DATA';
export const hadithOfTheDayData = payload => ({
  type: 'HADITH_OF_THE_DAY_DATA',
  payload: payload,
});

export const HADITH_OF_THE_MONTH_DATA = 'HADITH_OF_THE_MONTH_DATA';
export const hadithOfTheMonthData = payload => ({
  type: 'HADITH_OF_THE_MONTH_DATA',
  payload: payload,
});

export const HADITH_SEARCH_LOADER = 'HADITH_SEARCH_LOADER';
export const hadithSearchLoader = payload => ({
  type: 'HADITH_SEARCH_LOADER',
  payload: payload,
});

export const hadithSearchAction = (text, today, month, year, pageNumber, pageSize) => {
  return async dispatch => {
    dispatch(hadithSearchLoader(true));
    // setDeleteLoader(true)

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/hadithsearch?text=${text ? text : ''}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      headers: {},
    };

    axios(config)
      .then(response => {
        dispatch(hadithSearchData(response.data));

        // dispatch(getAllPostAction(status))
        dispatch(hadithSearchLoader(false));
        // setDeleteLoader(false)
        // handleOk()
      })
      .catch(error => {
        // setDeleteLoader(false)
        dispatch(hadithSearchLoader(false));
      });
  };
};

export const HADITH_SEARCH_DATA = 'HADITH_SEARCH_DATA';
export const hadithSearchData = payload => ({
  type: 'HADITH_SEARCH_DATA',
  payload: payload,
});

export const updateHadithAction = (obj, id, setConfirmLoader, text, today, month, year) => {
  return async dispatch => {
    if (setConfirmLoader) {
      setConfirmLoader(true);
    }
    delete obj._id;
    delete obj.__v;
    delete obj.updatedAt;
    delete obj.createdAt;
    delete obj.views;
    delete obj.recitation_audio_url;
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/allPost/updateDailyHadith?id=${id}`,
      headers: {
        'content-type': 'application/json',
      },
      data: obj,
    };

    axios(config)
      .then(response => {
        dispatch(hadithSearchAction(text, today, month, year));
        dispatch(hadithOfTheDayAction(today, month, year));
        if (setConfirmLoader) {
          setConfirmLoader(false);
        }
        if (obj.hadith_date_post) {
          toast.success('Hadith Has Been Added For The Day');
        } else {
          toast.success('Hadith Of The Date Has Been Removed');
        }
      })
      .catch(error => {
        if (setConfirmLoader) {
          setConfirmLoader(false);
        }
        toast.success('You Already have One hadith for today');
      });
  };
};
